import React, {
  SyntheticEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import Router from 'next/router'
import Player from 'xgplayer'
import FlvLivePlayer from 'xgplayer-flv-live'
// import FlvPlayer from 'xgplayer-flv'
import XgLiveLogger from '@byted/xgplayer-live-logger'
import moment from 'moment'
import { stringify } from 'querystring'
import { useCityName } from './hooks'
import getStatData from 'lib/page-enter'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { logger, metrics } from 'lib/slardar-utils'
import fetch from 'lib/decorated-fetch'

const close_icon = require('static/icon-liveclose-28@3x.png')
const lottie_icon = require('static/1-lottie@3x.png')
const live_stream_default_icon = require('static/live-stream-default.png')
const seriesGroup = [
  'page_series_compare_detail',
  // 'page_series_configuration',
  'page_series_home',
  'page_series_inquiry',
  // 'page_series_instruction_video_detail',
  'page_series_picture_detail',
  'page_series_real_picture',
  'page_series_video_list',
  'page_series_article_list',
]

const articleGroup = ['page_article_detail', 'page_ugc_article_detail']

interface ILiveStreamInfo {
  description: string
  title: string
  room_id_str: string
  user_id_str: string
  room_avatar: string
  button_text: string
  rtmp_pull_url: string
  orientation: 0 | 1
}

interface ILiveStreamWindow {
  city_name: string | undefined
  path: string | undefined
}

const LiveStreamWindow = React.memo(
  ({ city_name, path }: ILiveStreamWindow) => {
    const [liveStreamInfo, setLiveStreamInfo] = useState<ILiveStreamInfo>()
    const [rightOffset, setRightOffset] = useState(0)

    const [enterFrom, setEnterFrom] = useState<string>()
    const { orientation, button_text } = liveStreamInfo || {}
    const miniPlayer = useRef<any>()
    const [shouldShow, setShouldShow] = useState(true)
    const [seriesId, setSeriesId] = useState<string>()
    const windowRef = useRef<HTMLDivElement | null>(null)
    const shouldShowWindow = useMemo(() => {
      try {
        const { time } = JSON.parse(
          localStorage.getItem(`series-${seriesId || 'common-page'}`) || '{}'
        )
        if (time) {
          if (
            time >
            moment()
              .subtract(1, 'days')
              // .subtract(3, 'minutes') // For testing.
              .unix()
          ) {
            // less than 1 day
            return false
          } else {
            localStorage.removeItem(`series-${seriesId || 'common-page'}`)
            return true
          }
        }
        return true
      } catch (err) {
        console.error(err)
        metrics.counter(`should.show.window.exception`)
        logger.error(
          `[shouldshowwindow exception] item = series-${
            seriesId || 'common-page'
          } value = ${localStorage.getItem(
            `series-${seriesId || 'common-page'} error = ${err.message}`
          )}`
        )
        return false
      }
    }, [seriesId])

    const rejectWindow = useCallback(() => {
      if (localStorage.getItem(`series-${seriesId}` || 'common-page')) {
        // Aready set rejection.
        return
      }
      const obj = {
        time: moment().unix(),
      }
      try {
        localStorage.setItem(
          `series-${seriesId || 'common-page'}`,
          JSON.stringify(obj)
        )
      } catch (err) {
        metrics.counter('localStorage.setItem', { key: 'reject_window' })
        logger.warn(
          `[localstorage setitem error] Error setting  localstorage, err: ${err?.message}`
        )
      }
    }, [seriesId])

    useEffect(() => {
      setShouldShow(shouldShowWindow)
    }, [shouldShowWindow])

    useEffect(() => {
      const fetchWindow = async () => {
        const params = getStatData(window.location.pathname) || {}
        const { page_id, group_id } = params
        let enter_from
        let series_id = params.car_series_id
        if (seriesGroup.includes(page_id)) {
          enter_from = 'dcd_pc_series'
        } else if (articleGroup.includes(page_id)) {
          if (page_id === 'page_ugc_article_detail') {
            const articleJSON = await fetch(
              `/motor/info/ugc/short/article/v1/?group_id=${group_id}&from=pc_station`
            ).catch((e) => {
              // no-op
            })

            if (articleJSON?.data?.vid) {
              setLiveStreamInfo(undefined)
              return
            }
          } else {
            setLiveStreamInfo(undefined)
            return
          }

          enter_from = 'dcd_pc_article'
          const json = await fetch(
            `/motor/pc/content/get_information?group_id=${group_id}`
          ).catch((e) => {
            // no-op
          })
          series_id =
            json?.data?.motor_material_car_info?.[0]?.info?.list?.[0]?.series_id
        } else {
          if (
            // eslint-disable-next-line no-constant-condition
            page_id === 'page_series_instruction_video_detail' ||
            page_id === 'page_feed'
          ) {
            setLiveStreamInfo(undefined)
            return
          }
          enter_from = 'dcd_pc'
        }

        setSeriesId(series_id)
        setEnterFrom(enter_from)
        const json = await fetch(
          `/motor/m_api/pc_preview_window?${stringify({
            series_id,
            city_name,
            enter_from,
          })}`
        ).catch((e) => {
          // no-op
        })
        setLiveStreamInfo(json?.data?.cate_items?.[0])
      }
      try {
        fetchWindow()
      } catch (err) {
        console.error(err)
        setLiveStreamInfo(undefined)
      }
    }, [path])

    useEffect(() => {
      const constructPlayer = async () => {
        if (
          typeof window === 'undefined' ||
          typeof window.document === 'undefined' ||
          typeof window.document.createElement === 'undefined'
        ) {
          return
        }
        if (!liveStreamInfo) {
          return
        }
        // if (miniPlayer.current) {
        //   // Destroy前先pause   因为版本低所以中台同学说要这样兼容
        //   miniPlayer.current.pause()
        //   await miniPlayer.current.destroy(true)

        //   // 因版本问题 destroy(false) 不生效 还是会将dom移除
        //   // 短期解决办法： 重新生成节点插入。
        //   if (windowRef.current) {
        //     if (windowRef.current.firstElementChild?.id !== 'flv-player') {
        //       windowRef.current.insertAdjacentHTML(
        //         'afterbegin',
        //         `
        //     <div id="flv-player"></div>
        //   `
        //       )
        //     }
        //   }
        // }

        const url = liveStreamInfo.rtmp_pull_url

        const _player = new Player({
          id: 'flv-player',
          url: url.replace('http://', 'https://'),
          isLive: true,
          playsinline: true,
          width: orientation === 0 ? 170 : 256,
          height: orientation === 0 ? 303 : 170,
          autoplay: true,
          autoplayMuted: true,
          preloadTime: 3,
          retry: {
            count: 3, // 重试三次
            delay: 1000, // 重试间隔1秒
          },
          plugins: [FlvLivePlayer],
          ignores: [
            'time',
            'definition',
            'error',
            'fullscreen',
            'i18n',
            'loading',
            'mobile',
            'play',
            'poster',
            'progress',
            'replay',
            'volume',
          ],
          controls: false,
          closeVideoClick: true,
        })
        _player.on('error', (err: any) => {
          metrics.counter('flv.player.error')
          logger.warn(`[flvplayer error] flv-player error. error = ${err.ex}`)
          setLiveStreamInfo(undefined)
        })

        _player.on('ended', () => {
          setLiveStreamInfo(undefined)
        })

        // 参考https://web-bnpm.byted.org/package/@byted/xgplayer-live-logger
        // eslint-disable-next-line
        new XgLiveLogger({
          player: _player, // xgplayer播放器实例（必传）
          aid: '1839', // 应用id（必传）请在https://appcloud.bytedance.net/上申请
          project_key: 'auto_web_pc', //项目名称（必传）
          app_name: 'auto_web_pc', // app名称（必传）
          ext: {
            // 业务参数，可以自行传入，会携带在每条日志中
            enter_from: enterFrom,
            anchor_id: liveStreamInfo.user_id_str,
            room_id: liveStreamInfo.room_id_str,
          },
          onReport: (event_key: string, data: Record<string, any>) => {
            try {
              sendTeaCommEvent(event_key, data)
            } catch (err) {
              logger.error(`[json stringify fail] event_key = ${event_key}`)
            }
          },
        })

        miniPlayer.current = _player
      }
      constructPlayer()
    }, [liveStreamInfo])

    useEffect(() => {
      const body = document.body || document.documentElement
      setRightOffset((body.clientWidth - 1196) / 2)
    }, [path])

    const linkRef = (node: HTMLAnchorElement) => {
      if (node === null) {
        return
      }
      sendTeaCommEvent('show_float_live_window', {
        enter_from: enterFrom,
        room_id: liveStreamInfo?.room_id_str,
        anchor_id: liveStreamInfo?.user_id_str,
      })
    }

    const handleClose = (e: SyntheticEvent) => {
      e.preventDefault()
      e.stopPropagation()
      sendTeaCommEvent('click_float_live_window_close', {
        enter_from: enterFrom,
        room_id: liveStreamInfo?.room_id_str,
        anchor_id: liveStreamInfo?.user_id_str,
      })
      setShouldShow(false)
      rejectWindow()
    }

    const handleWindowClick = (e: SyntheticEvent) => {
      e.stopPropagation()
      if (!liveStreamInfo?.room_id_str) {
        e.preventDefault()
      }
      sendTeaCommEvent('click_float_live_window', {
        enter_from: enterFrom,
        room_id: liveStreamInfo?.room_id_str,
        anchor_id: liveStreamInfo?.user_id_str,
      })
    }

    return (
      <>
        {liveStreamInfo && shouldShow && (
          <a
            // eslint-disable-next-line react/jsx-no-target-blank
            target="_blank"
            rel="unsafe-url"
            href={`https://live.ixigua.com/room/${liveStreamInfo?.room_id_str}/`}
            onClick={handleWindowClick}
            ref={linkRef}
          >
            <div className="live-stream-window" ref={windowRef}>
              <div id="flv-player" />
              {/* 为了解决player自身阻止了冒泡的问题 */}
              <div className="transparent-layer" />
              <div className="close-icon-layer" />
              <span className="close-icon" onClick={handleClose} />
              <div className="title-wrapper">
                <span className="live-icon" />
                <span className="title">{button_text}</span>
              </div>
            </div>

            <style jsx>
              {`
                .live-stream-window {
                  position: fixed;
                  right: ${rightOffset}px;
                  bottom: 80px;
                  z-index: 999;
                  background-image: url('${live_stream_default_icon}');
                  background-size: 47px 40px;
                  background-repeat: no-repeat;
                  background-position: center;
                  background-color: #979aa8;
                  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
                }
                .live-stream-window::before {
                  content: '';
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  background-image: linear-gradient(
                    to bottom,
                    rgba(0, 0, 0, 0),
                    rgba(0, 0, 0, 0.72)
                  );
                  width: 100%;
                  height: 66px;
                  z-index: 1;
                }
                .close-icon {
                  width: 28px;
                  height: 28px;
                  background-image: url('${close_icon}');
                  background-size: contain;
                  background-position: center;
                  position: absolute;
                  top: 0;
                  right: 0;
                  cursor: pointer;
                }
                .transparent-layer {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  opacity: 0;
                }
                .close-icon-layer {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 30px;
                  border-radius: 1px;
                  background-image: linear-gradient(
                    to top,
                    rgba(0, 0, 0, 0),
                    rgba(0, 0, 0, 0.3)
                  );
                }
                .title-wrapper {
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 100%;
                  height: 66px;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  z-index: 2;
                }

                .live-icon {
                  width: 24px;
                  height: 24px;
                  background-image: url('${lottie_icon}');
                  background-size: contain;
                  background-position: center;
                  margin-bottom: 8px;
                  position: relative;
                }
                .live-icon::before {
                  content: '';
                  position: absolute;
                  left: -64px;
                  top: 12px;
                  width: 64px;
                  height: 1px;
                  background-color: rgba(255, 255, 255, 0.4);
                }
                .live-icon::after {
                  content: '';
                  position: absolute;
                  right: -64px;
                  top: 12px;
                  width: 64px;
                  height: 1px;
                  background-color: rgba(255, 255, 255, 0.4);
                }

                .title {
                  font-size: 14px;
                  line-height: 18px;
                  font-weight: 500;
                  color: white;
                }
              `}
            </style>
          </a>
        )}
      </>
    )
  }
)

// 来解决切页面时visibility变化导致组件刷新
const Wrapper = () => {
  const city_name = useCityName()
  return (
    <LiveStreamWindow city_name={city_name} path={Router?.router?.asPath} />
  )
}

export default Wrapper
